import { useState } from 'react';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { PageSection, PageSectionHeader } from 'components/page';
import {
  EmptyIndicator,
  LoadingIndicator,
  Pagination
} from 'components/common';
import { AnalyticsGroupFilter, AnalyticsPathsPath } from '.';

import type { PageState } from 'types';

export type AnalyticsPath = Pick<
  PageState['path'],
  'id' | 'owners' | 'title'
> & {
  stats: {
    deadlines: number;
    deadlinesAhead: number;
    deadlinesCompletedLate: number;
    deadlinesCompletedOnTime: number;
    deadlinesLate: number;
    numberOfParticipants: number;
    numberOfSteps: number;
    participantsCompleted: number;
    participantsNotStarted: number;
    participantsStarted: number;
  };
};

const AnalyticsPaths = () => {
  const { messages, user } = useReduxState();

  const [groupId, setGroupId] = useState(0);
  const [page, setPage] = useState(1);

  const { data, loading } = useApiData({
    url:
      `/admin/analytics/paths?page=${page}` +
      (groupId ? `&groupId=${groupId}` : '')
  });

  const filterGroups = (groupId: number) => {
    setGroupId(groupId);
    setPage(1);
  };

  return (
    <div className="paths">
      <PageSection>
        <PageSectionHeader
          description={
            user?.roles?.includes('superadmin')
              ? messages.analyticsPathsDescriptionSuperadmin
              : messages.analyticsPathsDescriptionAdmin
          }
          title={messages.paths}
        >
          <AnalyticsGroupFilter getGroupId={filterGroups} />
        </PageSectionHeader>

        {loading ? (
          <LoadingIndicator />
        ) : data?.paths && data?.paths?.length ? (
          <div className="list">
            {data.paths.map((path: AnalyticsPath) => (
              <AnalyticsPathsPath key={path.id} path={path} />
            ))}

            <Pagination
              currentPage={page}
              numberOfPages={data?.pages || 1}
              onPageChange={({ page }) => setPage(page)}
            />
          </div>
        ) : (
          <EmptyIndicator icon="users" title={messages.pathsEmpty} />
        )}
      </PageSection>
    </div>
  );
};

export default AnalyticsPaths;
